// TSS vite/04 §"Endpoint paths".
// Per-feature path helpers — keep URL knowledge local so a backend
// rename touches one file. Public channel (contract: public-recipients.md).

export const recipientPaths = {
    // GET public/recipients — parcerías del cliente, scoped por client_id del token.
    list:   () => 'public/recipients',
    detail: (id) => `public/recipients/${id}`,
    // Escrituras (Q-121). client_id/animal_id los fuerza/ignora el backend.
    create: () => 'public/recipients',
    update: (id) => `public/recipients/${id}`,
    remove: (id) => `public/recipients/${id}`,
    // GET public/stats — endpoint compartido; parcerías consume ?view=kpi →
    // data.recipients_kpi (agregado de receptoras, anclado en fecha T.E.).
    stats:  () => 'public/stats',
};
